/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockElementOptions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Element Option Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 01:41:55 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockElementOptionList = Loadable({
    loader: () => import('../containers/BlockElementOptions/BlockElementOptionListContainer'),
    loading: Loading,
});

export const BlockElementOptionForm = Loadable({
    loader: () => import('../containers/BlockElementOptions/BlockElementOptionEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockElementOptions.js